module.exports = __webpack_public_path__ + "static/media/PL.d3d44a88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PL.svg
// module id = 341
// module chunks = 0